module.exports = __webpack_public_path__ + "images/admin/unlimited-teams.png";